import { GoClock } from "react-icons/go";
import { CiCalendar } from "react-icons/ci";
import { FaCircle } from "react-icons/fa";
import { useEffect, useState } from "react";
import { Box, Modal } from "@mui/material";
import X from "../../../assets/imgs/circle-x.png";
import apiEndPoint from "../../../services/apiService/apiEndPoints";
import { getApi } from "../../../services/apiService/fetchMethod";
import MainLoader from "../../../commonComponents/loader/MainLoader";
import imgUrlChange from "../../../utils/imgUrlChanger";
import InfiniteScroll from "react-infinite-scroll-component";
import LoaderCircle from "../../../commonComponents/loader/LoaderCircle";
import { useSelector } from "react-redux";
import FilterBox from "../../../commonComponents/filterBox/FilterBox";
import LiveVideo from "./LiveVideo.jsx";
import { Empty } from "antd";

function Videos() {
  const [result, setResult] = useState([]);
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(true);
  const [videoUrl, setVideoUrl] = useState("");
  const [userLoginNow, setUserLoginNow] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const [noData, setNodata] = useState(false);
  const handleClose = () => setOpen(false);
  const { mode, selectedRangeDate, multiDate, selectedTabAll } = useSelector(
    (state) => state.filter
  );

  useEffect(() => {
    (async () => {
      let token = localStorage.getItem("Token");
      if (!token) {
        setLoading(false);
        setOpen(true);
      }
      const url =
        apiEndPoint().ALERT_PIPELINE +
        `?pageNumber=${pageNumber}&mode=${mode}&filter=${
          mode === 0
            ? selectedRangeDate
                ?.map((date) => date.format("YYYY-MM-DD"))
                ?.toString()
            : multiDate
                ?.map((date) => {
                  if (date?.calendar) {
                    return date?.format("YYYY-MM-DD");
                  } else {
                    return date;
                  }
                })
                ?.toString()
        }&live=${selectedTabAll === "video" ? false : true}`;
      const { data } = await getApi({ url });
      if (data?.data?.length === 0) {
        setNodata(true);
      }
      setResult((pre) => [...pre, ...data?.data]);
      setLoading(false);
      setOpen(false);
    })();
  }, [userLoginNow, mode, selectedRangeDate, multiDate, pageNumber,selectedTabAll]);
  useEffect(() => {
    setResult([]);
    setPageNumber(0);
  }, [mode, selectedRangeDate, multiDate,selectedTabAll]);
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    borderRadius: 1,
    bgcolor: "background.paper",
    boxShadow: 24,
    p:  0,
  };
  function formatDate(inputDate) {
    const date = new Date(inputDate);
    const options = { day: "2-digit", month: "short", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }
  const handleOpen = (url) => {
    setVideoUrl(url);
    setOpen(true);
  };
  const fetchMoreData = () => {
    setPageNumber((pre) => pre + 1);
  };
  if (selectedTabAll === "camera") {
    return (
      <LiveVideo result={result}/>
    );
  }
  if (loading) {
    return <MainLoader />;
  }
  return (
    <>
      <div className="container">
        <h4 className="dashHeading">Videos</h4>
        <div className=" d-flex justify-content-end">
          <FilterBox />
        </div>
        {result.length === 0 ? (
          <div className=" d-flex justify-content-center align-items-center" style={{height:"60vh"}}>
             <Empty />
          </div>
        ) : (
          <InfiniteScroll
            className="example2 row g-5"
            dataLength={result.length}
            next={fetchMoreData}
            hasMore={true}
            loader={
              <div className="d-flex justify-content-center align-items-center mt-3">
                {noData ? <div></div> : <LoaderCircle size={30} />}
              </div>
            }
          >
            {result?.map((item) => (
              <div className="col-lg-4">
                <div
                  className="card"
                  style={{
                    width: "23rem",
                    borderRadius: "8px",
                    overflow: "hidden",
                  }}
                >
                  <div className="container1">
                    <img
                      className="card-img-top image1"
                      src={imgUrlChange(item.videoId?.imgPath)}
                      height={200}
                      width={2000}
                      alt="not found"
                    />
                    <div className="middle1">
                      <div>
                        <svg
                          version="1.1"
                          id="play"
                          xmlns="http://www.w3.org/2000/svg"
                          x="0px"
                          y="0px"
                          height="70px"
                          width="70px"
                          viewBox="0 0 100 100"
                          enableBackground="new 0 0 100 100"
                          onClick={() =>
                            handleOpen(imgUrlChange(item.videoId.videoPath))
                          }
                        >
                          <path
                            className="stroke-solid"
                            fill="none"
                            stroke="white"
                            d="M49.9,2.5C23.6,2.8,2.1,24.4,2.5,50.4C2.9,76.5,24.7,98,50.3,97.5c26.4-0.6,47.4-21.8,47.2-47.7
                        C97.3,23.7,75.7,2.3,49.9,2.5"
                          />
                          <path
                            className="stroke-dotted"
                            fill="none"
                            stroke="white"
                            d="M49.9,2.5C23.6,2.8,2.1,24.4,2.5,50.4C2.9,76.5,24.7,98,50.3,97.5c26.4-0.6,47.4-21.8,47.2-47.7
                        C97.3,23.7,75.7,2.3,49.9,2.5"
                          />
                          <path
                            className="icon"
                            fill="white"
                            d="M38,69c-1,0.5-1.8,0-1.8-1.1V32.1c0-1.1,0.8-1.6,1.8-1.1l34,18c1,0.5,1,1.4,0,1.9L38,69z"
                          />
                        </svg>
                      </div>
                    </div>
                  </div>

                  <div className="middleBox mt-1">
                    <div style={{ fontWeight: "600" }}>
                      {item.videoId?.title}
                    </div>
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex  align-items-center mt-1">
                        <GoClock />{" "}
                        <span className="mx-2" style={{ fontWeight: 600 }}>
                          {item.videoId?.meta?.videoDuration}
                        </span>
                      </div>
                      <div className="d-flex  align-items-center mt-1">
                        <span className="mx-2" style={{ fontWeight: 600 }}>
                          {item.videoId?.meta?.videoSize}
                        </span>
                      </div>
                    </div>
                    <div className="d-flex flex-column mt-1 mb-2">
                      <div className="d-flex  align-items-center">
                        <CiCalendar size={18} />{" "}
                        <span className="mx-2" style={{ fontWeight: 600 }}>
                          {formatDate(item.createdAt)}
                        </span>
                      </div>
                      <div className="d-flex  align-items-center mt-1">
                        <FaCircle size={14} color="green" />{" "}
                        <span
                          className="mx-2"
                          style={{ fontWeight: 600, color: "green" }}
                        >
                          Report Available
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* <div className="footerVideo">View Report</div> */}
                </div>
              </div>
            ))}
          </InfiniteScroll>
        )}
      </div>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <span
            style={{
              position: "absolute",
              top: 0,
              right: "5px",
              cursor: "pointer",
            }}
            onClick={handleClose}
          >
            <img
              src={X}
              height={15}
              width={15}
              style={{ marginRight: "5px" }}
              alt="x"
            />
          </span>

          
            <div
              className="embed-responsive embed-responsive-16by9"
              style={{ width: "60rem", height: "40rem" }}
            >
              <iframe
                className="embed-responsive-item"
                src={videoUrl}
                style={{ width: "60rem", height: "40rem" }}
                title="Play Video"
              />
            </div>
          
        </Box>
      </Modal>
    </>
  );
}

export default Videos;
